import TruncatedConeGeometry from './truncated-cone-geometry';
import { uid } from '@luma.gl/webgl';
export default class CylinderGeometry extends TruncatedConeGeometry {
  constructor() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      id = uid('cylinder-geometry'),
      radius = 1
    } = props;
    super({ ...props,
      id,
      bottomRadius: radius,
      topRadius: radius
    });
  }

}
//# sourceMappingURL=cylinder-geometry.js.map